// Angular
import {Component, EventEmitter, Input, Output} from '@angular/core';
import { Observable, Observer } from 'rxjs';
// Model
import { FILE_EXTENSION } from './model/drag-and-drop-file.model';

@Component({
	selector: 'cv-drag-and-drop-file',
	templateUrl: './drag-and-drop-file.component.html',
	styleUrls: ['./drag-and-drop-file.component.scss']
})
export class DragAndDropFileComponent {

	@Input() message: string;
	@Input() acceptFormat: string = FILE_EXTENSION['*/*'];
	@Output() filesDropped = new EventEmitter<any>();

	public files: Array<any> = [];
	public fileExtensionFormats = FILE_EXTENSION;
	public formatNotSupported = false;

	/**
	 * Prepare the Upload File after dropping a file into the Container
	 * if File Accept Format is different all, validate the types matchs
	 * @param event
	 */
	public onFilesDropped(event: any): void {
		this.formatNotSupported = false;

		let validFileType = true;

		const files = event;
		if (files && files.length > 0) {
			const fileNameExtension = this.fileExtension(files[0].name.toLowerCase());
			const formatType = this.fileExtensionFormats[this.acceptFormat];
			if (this.acceptFormat !== this.fileExtensionFormats['*/*'] && formatType) {
				validFileType = formatType.indexOf(fileNameExtension) >= 0;
			}
		}

		this.formatNotSupported = !validFileType;

		if (validFileType) {
			this.emittingFiles(files);
		}
	}

	/**
	 * Prepare the Upload File
	 * @param event
	 */
	public onFilesChanged(event: any): void {
		this.formatNotSupported = false;

		const files = event.target.files;
		this.emittingFiles(files);

	}

	/**
	 * Prepare the Upload File
	 * @param files
	 */
	private emittingFiles(files: any){
		for (let index = 0; index < files.length; index++) {
			const element = files[index];
			this.files.push(element);
		}
		this.filesDropped.emit(this.files);
	}

	/**
	 * Delete the Attachment
	 * @param index
	 */
	public deleteAttachment(index: any): void {
		this.files.splice(index, 1);
		this.filesDropped.emit(this.files);
	}

	/**
	 * Get the Proper Format Size
	 * @param bytes
	 * @param decimals
	 */
	public formatBytes(bytes: any, decimals: any = 2): string {
		if (bytes === 0) {
			return '0 Bytes';
		}
		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		const i = Math.floor(Math.log(bytes) / Math.log(k));
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

	/**
	 * Get the File Extension
	 * @param name
	 */
	public fileExtension(name: string): string {
		return name.slice((Math.max(0, name.lastIndexOf('.')) || Infinity) + 1);
	}

	/**
	 * Get the possible file Type
	 * @param name
	 */
	public fileTypeImg(name: string): string {
		const fileType = this.fileExtension(name);
		if (fileType === 'xml' || fileType === 'XML' || fileType === 'ENV' || fileType === 'env' || fileType === 'pdf' || fileType === 'PDF') {
			return 'fa-file-code';
		}
		return 'fa-file-o';
	}

	/**
	 * change event handler for automation.
	 */
	async onChange(event: any): Promise<void> {
		this.formatNotSupported = false;
		try {
			const values = JSON.parse(event.target.value);
			const files = [];

			for (let i = 0; i < values.length; i++) {
				const newImage = values[i];
				let dataType = '';
				switch (newImage.charAt(0).toLowerCase()) {
					case '/': dataType = 'image/jpeg'; break;
					case 'i': dataType = 'image/png'; break;
					case 'r': dataType = 'image/gif'; break;
					case 'u': dataType = 'image/webp'; break;
				}

				const blob = await this.dataURItoBlob(newImage, dataType).toPromise();
				const imageName = this.generateName(dataType);
				const imageFile: File = new File([blob], imageName, {type: dataType});

				files.push(imageFile);
			}

			this.onFilesDropped(files);

		} catch (error) {
			console.error('Input invalid', error);
		}
	}

	/**
	 * Method to Generate a Name for the Image
	 */
	generateName(dataType: string): string {
		const date: number = new Date().valueOf();
		let text = '';
		const possibleText = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		for (let i = 0; i < 5; i++) {
			text += possibleText.charAt(
				Math.floor(Math.random() * possibleText.length)
			);
		}
		// Replace extension according to your media type like this
		return `${date}.${text}.${dataType.split('/')[1]}`;
	}

	/**
	 * doc must
	 * @param dataURI
	 */
	dataURItoBlob(dataURI: string, dataType: string): Observable<Blob> {
		return new Observable((observer: Observer<Blob>) => {
			const byteString: string = window.atob(dataURI);
			const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteString.length);
			const int8Array: Uint8Array = new Uint8Array(arrayBuffer);

			for (let i = 0; i < byteString.length; i++) {
				int8Array[i] = byteString.charCodeAt(i);
			}

			const blob = new Blob([int8Array], { type: dataType });

			observer.next(blob);
			observer.complete();
		});
	}
}
